<template>
    <MonitorLayoutTemplate
        :table_title="table_title"
        :is_show_chart_dialog="is_show_chart_dialog"
    >
        <template v-slot:datetime>
            <QpeDatetime
                :props_date="date"
                :props_time="time"
                :name="default_value"
                @update-time="update_time"
                @change-parent-date-time="change_parent_date_time"
            />
        </template>

        <template v-slot:filter_condition_options>
            <MonitorOptionSet 
                :option_set="option_set"
                @filter_data="filter_data" 
            />
        </template>
            
        <template v-slot:data_table="slot_props">
            <QpeDatatable
                :data="table_data"
                :headers="header"
                :name="default_value"
                :error_text="error_text"
                :search="slot_props.search"
                :should_draw_diagram_header="should_draw_diagram_header"
                :enable_diagram_slot="true"
                :should_show_raw_html_header="should_show_raw_html_header"
                :show_download_pdf_btn="true"
                @update-time="update_time"
                @change-parent-date-time="change_parent_date_time"
                @open-chart="assign_chart_component"
                :is_show_chart_dialog_parent.sync="is_show_chart_dialog"
            >
                <template v-slot:diagram_dialog="{ close_dialog }">
                    <GisChart v-if="is_show_chart_dialog"
                        id="belongs_monitor_chart"
                        :chart_options="chart_options"
                        :default_variable="$t('__rainfall.rainfall')"
                        :prop_rain_selected="current_table_header"
                        @close-chart-dialog="close_dialog"
                    />
                </template>
                <template v-slot:table_description>
                    <span> 說明："--"標示，顯示該欄位無資料。</span>
                </template>
            </QpeDatatable>
        </template>
    </MonitorLayoutTemplate>
</template>

<script>
    import { redirect_monitor_table_ajax } from "@/utils/monitor/monitor.js"
    import { get_stations_history_params } from "@/utils/chart/chart_ajax.js"
    import { monitor_mixin } from "@/utils/monitor/monitor_mixin.js"
    import {
        TABLE_VALUE_TEXT_MAPPING,
        dot_color_mapping
    } from "@/config/monitor_config.js"
    import cloneDeep from 'lodash/cloneDeep'
    import MonitorLayoutTemplate from "@/components/monitor/_tool/layout_template.vue"
    import QpeDatetime from "@/components/monitor/qpe_datetime.vue"
    import MonitorOptionSet from "@/components/monitor/monitor_option_set.vue"
    import QpeDatatable from "@/components/monitor/qpe_datatable.vue"

	export default {
        name: 'child_area_rainfall',
        
        components: {
            MonitorLayoutTemplate,
            QpeDatetime,
            MonitorOptionSet, 
            QpeDatatable, 
            GisChart: () => import('@/components/chart/gis_chart.vue')
        },

        mixins: [monitor_mixin],

        props: {
            default_value: {
                type: Number,
                required: true,
            },

            option_local_storage_name: {
                type:String,
                required: true,
            },
        },

        data() {
			return {
                header: [],
                table_data: [],
                error_text: '',

                // filter使用
                immutable_table_data: [],
                option_set: [],
                display_all_route: '所有路線',

                should_draw_diagram_header: ['10分鐘', '1小時', '3小時', '6小時', '12小時', '24小時', '48小時', '72小時'],

                is_show_chart_dialog: false,
                chart_options: {
                    type: { 'gauge': true }
                },
                current_table_header: '',

                should_show_raw_html_header: [
                    '七級暴風圈警示',
                ],

                TABLE_VALUE_TEXT_MAPPING: TABLE_VALUE_TEXT_MAPPING,
            }
        },

        computed: {
            table_title() {
                return `${TABLE_VALUE_TEXT_MAPPING[this.default_value]['tag_name']}資訊`
            }
        },
        
        watch: {
            immutable_table_data() {
                if (this.immutable_table_data) {
                    this.init_option_set()
                    this.update_option_set_from_local_storage()
                }
            },
        },

        created() {
            redirect_monitor_table_ajax.call(this, this.default_value)
        },

		methods: {
            generate_table_data (data, header) {
                this.immutable_table_data = data;
                this.table_data = this.reconstruct_alert_content(this.sort_table_data(data));
                this.header = header;
            },

            init_option_set() {  
                let option_set_array = [
                    {current_option_value: this.display_all_route, json_key:'國道名稱', label: 'route'},
                    ]

                option_set_array.forEach(item => {
                    if(!item.option_array || item.option_array.length == 1) {
                        item.option_array = this.table_data.map(item2 => {
                            return item2[item.json_key]
                        });
                        item.option_array = [item.current_option_value, ...new Set(item.option_array)]
                    }
                })
                this.option_set = option_set_array
            },

            filter_data(filtered_cond) {
                if (this.option_set[0].current_option_value != filtered_cond['route']) {
                    this.option_set[0].current_option_value = filtered_cond['route']
                }
                
                let compare_route
                filtered_cond['route'] === this.display_all_route ? compare_route = '' : compare_route = filtered_cond['route']
        
                let filtered_data = this.immutable_table_data.filter(function(item) {
                    return (
                        item['國道名稱'].includes(compare_route)
                    )
                })
                this.table_data = this.reconstruct_alert_content(this.sort_table_data(filtered_data))

                // 把目前選擇的 option 存起來
                localStorage.setItem(this.option_local_storage_name, JSON.stringify(filtered_cond))
            },
    
            sort_table_data(data) {
                // '七級暴風圈警示' 目前得知的回傳值是數字
                return data.sort((datum) => +datum['七級暴風圈警示'] ? -1 : 0);
            },

            reconstruct_alert_content(data) {
                return cloneDeep(data).map(datum => {
                    const be_concat_object = {}
                    this.should_show_raw_html_header.forEach(html_header => {
                        const dot_color = dot_color_mapping[datum[html_header]]
                        if(dot_color) {
                            be_concat_object[html_header] = [{
                                'html': `<span class="dot" style="background: ${dot_color}"/>`
                            }]
                        }
                    })
                    return Object.assign(datum, be_concat_object)
                })
            },

            assign_chart_component(header_name, choosed_value, current_row_data) {
                this.current_table_header = header_name
                this.chart_options = { 
                    ...this.chart_options, 
                    ...get_stations_history_params.call(this, current_row_data) 
                }
            },

            update_option_set_from_local_storage() {
                const child_area_rainfall_option = JSON.parse(localStorage.getItem(this.option_local_storage_name))
                if (child_area_rainfall_option && Object.keys(child_area_rainfall_option).length !== 0) {
                    this.option_set[0].current_option_value = child_area_rainfall_option.route
                }
            },
        },
	}
</script>

<style>
</style>